import axiosInstance from "../apis";
import axios from "axios";
import { AxiosResponse } from "axios";
import fileDownload from "js-file-download";
import { BASE_URL_V2 } from '../constants';

export const uploadFile = (
  file: any,
  uploadUrl: string
): Promise<AxiosResponse> => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(uploadUrl, file, {
        headers: {
          "Content-Type": "application/octet-stream",
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => resolve(res))
      .catch((e) => reject(e));
  });
};

export const uploadFileToS3 =  async (body: {
  type: 'file' | 'link',
  path: string,
  file?: any
  link?: string
}) => {
  return await axiosInstance.post<{link: string}>("admin/images", body,{
    baseURL: BASE_URL_V2,
    headers: {
      "Content-Type": 'multipart/form-data',
    }
  })
}

export const downloadFile = (url: string, filename: string, params: any) => {
  axios
    .get(url, {
      responseType: "blob",
      params,
    })
    .then((res) => {
      fileDownload(res.data, filename);
    });
};
